
import { defineComponent } from "vue"


export default defineComponent({
  name: 'task-scenetype1-execution',
})
